export const control_type = [
    {
        label:'科技侠',
        value:0
    },
    {
        label: '微耕',
        value: 1
    }
]